import {
    RecordStenographyDetailApiV1AdjutantAppRecordStenographyRecordStenographyIdGetParams,
    RecordStenographyDetailApiV1AdjutantAppRecordStenographyRecordStenographyIdShareGetParams,
    RecordStenographyDTO,
    RecordStenographyListApiV1AdjutantAppRecordStenographyGetParams,
    RecordStenographyListOutputDTO,
    RecordStenographyPublicDTO,
} from '../swagger/dto'
import { getRequest } from './config'
import { STENOGRAPHY_URL } from './endpoints.constants'

export const getStenographyList = async (
    params: RecordStenographyListApiV1AdjutantAppRecordStenographyGetParams,
) => {
    const response = await getRequest<RecordStenographyListOutputDTO>(STENOGRAPHY_URL, params)
    return response.data
}

export const getStenographyDetail = async (
    params: RecordStenographyDetailApiV1AdjutantAppRecordStenographyRecordStenographyIdGetParams,
) => {
    const response = await getRequest<RecordStenographyDTO>(
        `${STENOGRAPHY_URL}/${params.recordStenographyId}`,
    )

    return response.data
}

export const getStenographyShare = async (
    params: RecordStenographyDetailApiV1AdjutantAppRecordStenographyRecordStenographyIdShareGetParams,
) => {
    const response = await getRequest<RecordStenographyPublicDTO>(
        `${STENOGRAPHY_URL}/${params.recordStenographyId}/share`,
    )

    return response.data
}
